<template>
    <div class="row">
        <div class="col">

            <div v-for="question in pages[currentIdx]['questions']" :key="question.variable">

                <!-- reused input types -->
                <radio-default 
                    v-if="question.template == 'RadioDefault'" 
                    :question="question"
                ></radio-default>
                <checkbox-default 
                    v-if="question.template == 'CheckboxDefault'" 
                    :question="question"
                ></checkbox-default>
                <checkbox-header 
                    v-if="question.template == 'CheckboxHeader'" 
                    :question="question"
                ></checkbox-header>
                <number-label 
                    v-if="question.template == 'NumberLabel'" 
                    :question="question"
                ></number-label>
                <static-optional-header 
                    v-if="question.template == 'StaticOptionalHeader'" 
                    :question="question"
                ></static-optional-header>
                <text-conditional-followup
                    v-if="question.template == 'TextConditionalFollowup'" 
                    :question="question"
                ></text-conditional-followup>
                <radio-header
                    v-if="question.template == 'RadioHeader'" 
                    :question="question"
                ></radio-header>
                <select-header 
                    v-if="question.template == 'SelectHeader'" 
                    :question="question"
                ></select-header>

                <!-- custom, single question input types -->
                <height-feet-inches
                    v-if="question.template == 'HeightFeetInches'" 
                    :question="question"
                ></height-feet-inches>
                <delivery-date-survey2
                    v-if="question.template == 'DeliveryDate'" 
                    :question="question"
                ></delivery-date-survey2>
                <weight-pounds-ounces
                    v-if="question.template == 'WeightPoundsOunces'" 
                    :question="question"
                ></weight-pounds-ounces>
                <radio-babies-status 
                    v-if="question.template == 'RadioBabiesStatus'" 
                    :question="question"
                ></radio-babies-status>
                <radio-babies-nicu 
                    v-if="question.template == 'RadioBabiesNicu'" 
                    :question="question"
                ></radio-babies-nicu>
                <radio-babies-nicu-length 
                    v-if="question.template == 'RadioBabiesNicuLength'" 
                    :question="question"
                ></radio-babies-nicu-length>

            </div><!-- v-for -->
        </div><!-- .col -->
    </div><!-- .row -->
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../stores/surveys'

    // components for reused form inputs
    import TextConditionalFollowup from './question_templates/TextConditionalFollowup.vue'
    import RadioDefault from './question_templates/RadioDefault.vue'
    import CheckboxDefault from './question_templates/CheckboxDefault.vue'
    import CheckboxHeader from './question_templates/CheckboxHeader.vue'
    import NumberLabel from './question_templates/NumberLabel.vue'
    import StaticOptionalHeader from './question_templates/StaticOptionalHeader.vue'
    import RadioHeader from './question_templates/RadioHeader.vue'
    import SelectHeader from './question_templates/SelectHeader.vue'

    // components for question specific form inputs
    import HeightFeetInches from './question_templates/HeightFeetInches.vue'
    import DeliveryDateSurvey2 from './question_templates/DeliveryDate.vue'
    import WeightPoundsOunces from './question_templates/WeightPoundsOunces.vue'
    import RadioBabiesStatus from './question_templates/RadioBabiesStatus.vue'
    import RadioBabiesNicu from './question_templates/RadioBabiesNicu.vue'
    import RadioBabiesNicuLength from './question_templates/RadioBabiesNicuLength.vue'

    const { pages, currentIdx } = storeToRefs(useSurveysStore())
</script>
